import { Chain } from '@1delta/chain-registry'
import { initConfig } from '@1delta/data-sdk'

export function getInitPosManagerAddress(chainId: string) {
  // @ts-ignore
  return addressesInitCore.PosManager[chainId]
}

export function getInitCoreAddress(chainId: string) {
  // @ts-ignore
  return addressesInitCore.Core[chainId]
}

export function getInitLensAddress(chainId: string) {
  // @ts-ignore
  return addressesInitCore.PublicLens[chainId]
}

const addressesInitCore = {
  InitOracle: {
    [Chain.MANTLE]: '0x4E195A32b2f6eBa9c4565bA49bef34F23c2C0350',
  },
  Core: {
    [Chain.MANTLE]: '0x972BcB0284cca0152527c4f70f8F689852bCAFc5',
  },
  Config: {
    [Chain.MANTLE]: '0x007F91636E0f986068Ef27c950FA18734BA553Ac',
  },
  PosManager: {
    [Chain.MANTLE]: '0x0e7401707CD08c03CDb53DAEF3295DDFb68BBa92',
  },
  Lens: {
    [Chain.MANTLE]: '0x7d2b278b8ef87bEb83AeC01243ff2Fed57456042',
  },
  PublicLens: {
    [Chain.MANTLE]: '0xDf75fF0452eDf4897B051A54b406eB384503Ac39',
  },
}

function getInitPools(
  chainId: string,
  lender: string,
): {
  poolId: string
  underlying: string
}[] {
  const entries = initConfig()?.[lender]?.[chainId]
  if (!entries) return []

  return entries.map((entry) => ({
    poolId: entry.pool,
    underlying: entry.underlying,
  }))
}

export function getInitUnderlyingToPoolMap(
  chainId: string,
  lender: string,
): Map<string, string> {
  return getInitPools(chainId, lender).reduce((map, { underlying, poolId }) => {
    map.set(underlying, poolId)
    return map
  }, new Map<string, string>())
}
